export const statuses = [
  {
    name: 'active',
    displayName: 'Active',
  },
  {
    name: 'archive',
    displayName: 'Archived',
  },
  {
    name: 'blocked',
    displayName: 'Blocked',
  },
  {
    name: 'deleted',
    displayName: 'Deleted',
    hidden: true,
  },
  {
    name: 'new',
    displayName: 'New',
  },
]
